import * as actionTypes from "../ActionTypes";

// ✅ Save Give Setting
export const saveGiveSettingRequest = (apiPayloadRequest, callback) => ({
  type: actionTypes.SAVE_GIVESETTING_REQUEST,
  payload: { apiPayloadRequest },
  callback,
});

export const saveGiveSettingSuccess = (data) => ({
  type: actionTypes.SAVE_GIVESETTING_SUCCESS,
  payload: data,
});

export const saveGiveSettingFailure = (error) => ({
  type: actionTypes.SAVE_GIVESETTING_FAILURE,
  payload: error,
});

// ✅ Update Give Setting
export const updateGiveSettingRequest = (apiPayloadRequest, callback) => ({
  type: actionTypes.UPDATE_GIVESETTING_REQUEST,
  payload: { apiPayloadRequest },
  callback,
});

export const updateGiveSettingSuccess = (data) => ({
  type: actionTypes.UPDATE_GIVESETTING_SUCCESS,
  payload: data,
});

export const updateGiveSettingFailure = (error) => ({
  type: actionTypes.UPDATE_GIVESETTING_FAILURE,
  payload: error,
});

// ✅ Delete Give Setting
export const deleteGiveSettingRequest = (payload, callback) => ({
  type: actionTypes.DELETE_GIVESETTING_REQUEST,
  payload,
  callback,
});

export const deleteGiveSettingSuccess = (data) => ({
  type: actionTypes.DELETE_GIVESETTING_SUCCESS,
  payload: data,
});

export const deleteGiveSettingFailure = (error) => ({
  type: actionTypes.DELETE_GIVESETTING_FAILURE,
  payload: error,
});
